<script>
export default {
  props: {
    message: {
      type: String,
      default: ""
    }
  }
}
</script>

<template>
  <div class="loading-overlay position-fixed w-100 h-100 d-flex align-items-center flex-column justify-content-center">
    <div class="kenwood-loader"></div>
    <div class="loading-message">
      <p class="px-3 text-center px-sm-5 h5">{{message}}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.loading-overlay {
  top:0;
  left:0;
  z-index:9999;
  background-color: rgba($white, 0.9);
}
</style>
